export default __webpack_public_path__ + "static/out-team-mobile-1d9fd0677500565ad465752e3b614c28.png";